import { IMAGE_PATHS } from 'constants/imagePaths';
import React from 'react';
import { Image } from 'react-bootstrap';
import useTranslate from 'hooks/useTranslate';
import useAuthStore from 'store/auth';
import { S3_URL, USER_TYPES } from 'constants/index';
import { unitNumber, withAuth } from 'utils';
import { useNavigate } from 'react-router-dom';
import './styles.scss';
import { useStaticUserDetailsQuery } from 'services';

interface ProfileProps {
	onClose?: () => void;
}

const Profile: React.FC<ProfileProps> = ({ onClose }) => {
	const { token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { translate } = useTranslate();
	const { data: staticUserDetails } = useStaticUserDetailsQuery({
		enabled: !token, // Only call the query when there's no token
	});
	const userDetails = token ? useAuthStore((state) => state.userInfo.user) : staticUserDetails;
	const navigate = useNavigate();

	const goToConnectionList = () => {
		if (userDetails?.userType === USER_TYPES.COMPANY) {
			navigate('/company/followers-list?activeTab=followers&value=');
		} else {
			navigate(`/seeker/my-connections?activeTab=connected&value=`);
		}
		if (typeof onClose === 'function') onClose();
	};

	const goToFollowingList = () => {
		navigate(`/${userDetails?.userType}/followings-list?activeTab=company&value=`);
		if (typeof onClose === 'function') onClose();
	};

	const goToEmployeeList = () => {
		navigate(`/company/followers-list?activeTab=employees&value=`);
		if (typeof onClose === 'function') onClose();
	};

	return (
		<>
			<div>
				<div className="w-100 user-profile-bg">
					<Image
						src={
							userDetails?.coverPicture
								? `${S3_URL}${userDetails.coverPicture}`
								: IMAGE_PATHS.UserBG
						}
						alt="bg"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
				<div
					className="user-profile mx-auto"
					onClick={() =>
						navigate(token ? `/${userDetails?.userType}/profile` : `/static/profile`, {
							state: { userDetails },
						})
					}
				>
					<Image
						src={
							userDetails?.profilePicture
								? `${S3_URL}${userDetails.profilePicture}`
								: IMAGE_PATHS.UserDefault
						}
						alt="img"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
			</div>
			<div
				className="user-info"
				onClick={withAuth(token, () => {
					if (onClose) {
						onClose();
					}
					navigate(token ? `/${userDetails?.userType}/profile` : `/static/profile`, {
						state: { userDetails },
					});
				})}
			>
				<h4 className="mb-1 fw-bold">
					{userDetails?.userType === USER_TYPES.COMPANY
						? userDetails?.companyName
						: `${userDetails?.firstName} ${userDetails?.lastName}`}
				</h4>
				<p className="mb-0">
					{userDetails?.userType === USER_TYPES.COMPANY
						? `${userDetails?.industryName} ${userDetails?.industryName?.length > 0 ? ',' : ''} ${userDetails?.address}`
						: userDetails?.designation}
				</p>
			</div>
			<div className="d-flex justify-content-center gap-2">
				<p
					style={{ cursor: 'pointer' }}
					className="mb-0"
					onClick={withAuth(token, goToConnectionList)}
				>
					<span>
						{unitNumber(
							userDetails?.userType === USER_TYPES.COMPANY
								? userDetails?.followers
								: userDetails?.connection,
							0,
						)}
					</span>{' '}
					{userDetails?.userType === USER_TYPES.COMPANY
						? translate('Common.followers')
						: translate('Common.connection')}
				</p>
				{userDetails?.userType === USER_TYPES.COMPANY && <p className="mb-0">•</p>}
				{userDetails?.userType === USER_TYPES.COMPANY && <p
					style={{ cursor: 'pointer' }}
					className="mb-0"
					onClick={withAuth(token, goToFollowingList)}
				>
					<span>{unitNumber(userDetails?.followings, 0)}</span> {translate('Sidebar.followings')}
				</p>}
			</div>
			{/* {userDetails?.userType === USER_TYPES.COMPANY && (
				<div style={{ marginTop: '-10px' }}>
					<p
						style={{ cursor: 'pointer' }}
						className="mb-0"
						onClick={withAuth(token, goToEmployeeList)}
					>
						<span>{unitNumber(userDetails?.employees, 0)}</span> {translate('Common.employees')}
					</p>
				</div>
			)} */}
		</>
	);
};

export default Profile;
